import axios from "../axios";
import { IServiceProvidersSearchOptions } from "../store/actions/serviceProviderActions";

export const getOrganizationImage = async (id?: string) => {
  const queryString = id ? `?id=${id}` : '';
  try {
    const resp = await axios.get(`/json/organizations/image${queryString}`)
    return resp.data;
  } catch (error) {
    console.error(error);
  }
};


export const exportBilling = async (id?: number) => {
  const url = id ? `/json/billing/export?id=${id}`: `/json/billing/exportall`;
  try {
    const resp = await axios.get(url);
    return resp.data.csvString;
  } catch (error) {
    console.error(error);
  }
};

export const exportServiceProviders = async (id?: number, options?: IServiceProvidersSearchOptions) => {
  const url = id ? `/json/export/serviceprovider?id=${id}` : `/json/export/serviceproviders`;
  try {
    const cleanParams: Record<string, string> = {};
    if (!id && options) {
      if (options.operatorId) cleanParams.operatorId = options.operatorId;
      if (options.locationId) cleanParams.locationId = options.locationId;
      if (options.serviceId) cleanParams.serviceId = options.serviceId;
      if (options.subscriptionLevel) cleanParams.subscriptionLevel = options.subscriptionLevel;
      if (options.paymentMethod) cleanParams.paymentMethod = options.paymentMethod;
    }
    const resp = await axios.get(url, {
      params: Object.keys(cleanParams).length > 0 ? cleanParams : undefined,
    });
    return resp.data.csvString;
  } catch (error) {
    console.error(error);
  }
};
